/**
 * Reglas para copiar el valor de un campo de Persona a otro.
 *
 * Los nombres de campo deben corresponder al `fieldname` entregado por el
 * template, sin el prefijo `pii.` usado internamente en la vista de alta.
 *
 * Estructura:
 * {
 *   company: 8,
 *   template: 4,
 *   rolToApply: [1069, 1068],
 *   sourceField: 'campo_origen',
 *   targetField: 'campo_destino',
 * }
 *
 * `rolToApply` es opcional. Si se omite o está vacío, la regla se aplica a
 * todos los roles. Cuando contiene IDs, solo aplica al rol actual del usuario.
 *
 * Para selects, el valor solo se escribe cuando existe una opción equivalente
 * en el campo destino. Los campos text y boolean copian el valor tal cual.
 */
const personFieldValueSyncRules = [
  {
    company: 8,
    template: 4,
    /* 1069 Mesa de Control Gerente | 1068 Onboarding Capturista | 1070 Mesa de Control Analista | 1071 Soporte */
    rolToApply: [1069, 1068, 1070, 1071],
    sourceField: 'actividad_economica_simplificado',
    targetField: 'actividad_economica',
  },
  {
    company: 8,
    template: 4,
    /* 1069 Mesa de Control Gerente | 1068 Onboarding Capturista | 1070 Mesa de Control Analista | 1071 Soporte */
    rolToApply: [1069, 1068, 1070, 1071],
    sourceField: 'actividad_economica_simplificado',
    targetField: 'actividad_cuestionario',
  },
];

export default personFieldValueSyncRules;
